module.exports = __webpack_public_path__ + "static/media/DoorHandle4.91bfefe5.jpg";